import './allMediasViewerGeneric.css';

import PhotoGrid from 'justifiedgallery';

import { allMediasViewerGenericTpl } from './allMediasViewerGenericTpl';

import { getSeason } from '../../utils/js/getSeason';

$.expr[':']['in-viewport'] = function (e, idx, meta) {
  const $elem = $(e);

  let parameters = null;
  if (meta[3]) {
    parameters = meta[3].split(',');
  }

  const positionTop = parameters && parseFloat(parameters[1]) || 0;
  const innerHeight = parameters && parseFloat(parameters[2]) || window.innerHeight;
  const threshold = (parameters && parameters[0].slice(-1) === '%' ? (parseFloat(parameters[0]) * innerHeight / 100) : parseFloat(parameters[0])) || 0;
  const boundingClientRect = $elem.get(0).getBoundingClientRect();

  return boundingClientRect.top - positionTop - threshold <= 0;
};

export const allMediasViewerGeneric = {
  config: null,
  $viewer: null,
  currentTab: null,
  currentSubsection: null,
  $tabs: null,
  $subsections: {},
  mainSelector: '.js-allMediasViewerGeneric',
  sectionSelector: '.js-allMediasViewerGeneric-section',
  navSelector: '.js-allMediasViewerGeneric-nav',
  closeSelector: '.js-allMediasViewerGeneric-close',
  bodySelector: '.js-allMediasViewerGeneric-body',
  tabSelector: '.js-allMediasViewerGeneric-tab',
  photoTabSelector: '.js-allMediasViewerGeneric-tab--',
  subSectionSelector: '.js-allMediasViewerGeneric-subsection',
  headerSelector: '.js-allMediasViewerGeneric-header',
  photoGrid: null,
  cache: {},
  defaultSeason: 'SUMMER',
  currentSeason: '',
  isScrolling: false,
  lastScrollTop: 0,
  bodyTop: 0,
  bodyHeight: 0,
  fancyboxPhotosResolution: '800x600',
  fancyboxViewBaseOptions: {
    buttons: ['close'],
    overlayClose: false,
    isModal: false,
    preventScroll: true,
    clickSlide: false,
    clickOutside: false,
    touch: true,
    loop: true,
    baseClass: 'fancybox-skin--white fancybox-skin--white_slide-in-left'
  },
  templates: {
    grid: {
      elem: function (image, isPixlee) {
        return `<div class="allMediasViewerGeneric-grid--elem${isPixlee ? ' pixlee' : ''}" data-index="${image.index}">
        <img class="loading" src="${image.src}" width="${image.width}" height="${image.height}" alt="" />
        ${image.network === 'instagram' ? '<i class="icon icon-photos-clients"></i>' : ''}
        <div class="cp-spinner">
          <i></i>
        </div>
      </div>`;
      }
    },
    lightview: {
      photo: function (image) {
        return `
        <div class="fancyboxPhoto-container">
          <p class="fancyboxPhoto-content--pagination">${image.caption}</p>
          <p class="fancyboxPhoto-content--label">${image.subsectionLabel}</p>
          <div class="fancyboxPhoto-image">
            <div class="fancyboxPhoto-image--container" data-width="${image.width}" data-height="${image.height}">
              <img class="fancyboxPhoto-image--inner" src="${image.src}" />
            </div>
          </div>
          <p class="fancyboxPhoto-content--legend">${image.photoLegend}</p>
        </div>`;
      },
      pixlee: function (image) {
        return `
        <div class="fancyboxPixlee-container">
          <p class="fancyboxPixlee-content--pagination">${image.caption}</p>
            <div class="fancyboxPixlee-image">
              <div class="fancyboxPixlee-image--container" data-width="${image.width}" data-height="${image.height}">
                <img class="fancyboxPixlee-image--inner" src="${image.src}" />
                <i class="icon icon-photos-clients"></i>
                <div class="cp-spinner">
                  <i></i>
                </div>
              </div>
            </div>
          <p class="fancyboxPixlee-content--comment js-fancybox-contentComment"><span class="fancyboxPixlee-content--name" >@${image.user_name}</span>${image.description}</p>
        </div>`;
      }
    }
  },

  init: function (config, tab) {
    if (!tab) {
      return false;
    }

    if (!this.config) {
      this.config = config;
    }

    this.photoGrid = PhotoGrid;

    if (this.$viewer === null) {
      this.$viewer = $(allMediasViewerGenericTpl(config));
      $('body').append(this.$viewer);
      this.$tabs = this.$viewer.find('.allMediasViewerGeneric-tabs');
      this.initEvents();
    }

    setTimeout(() => {
      this.show(tab);
    }, 10);

    window.addEventListener('orientationchange', function () {
      const target = document.querySelector('.js-allMediasViewerGeneric-section--video.active.loaded');
      if (screen.orientation.angle != 0 && !!target) {
        if (target.requestFullscreen) target.requestFullscreen();
        else if (target.webkitRequestFullscreen) target.webkitRequestFullscreen();
        else if (target.mozRequestFullScreen) target.mozRequestFullScreen(); //FF 9 a 63
        else if (target.webkitEnterFullscreen) target.webkitEnterFullscreen(); // iOS
      }
    });
  },

  show(tab, trackingOnClickNav) {
    const section = this.getSection(tab);
    section.subsections.forEach((subsection) => {
      if (!this.cache[`${tab}${subsection.name}`]) {
        this.cache[`${tab}${subsection.name}`] = {
          images: [],
          grid: []
        };
      }
    });
    if (this.$viewer.hasClass('closed')) {
      this.$viewer.removeClass('closed');
    }
    if (tab === 'photo') {
      this.setSeasonPhotos();
    }
    this.goToTab(tab);
    if (this.config.tracking && this.config.tracking.onShow) {
      Tracking.dataLayerPush(this.config.tracking.onShow);
    }
    if (trackingOnClickNav === true && section.tracking && section.tracking.onClickNav) {
      Tracking.dataLayerPush(section.tracking.onClickNav);
    }
    genericScrollTo.canIScroll(DEVICE.isMobile);
  },

  hide() {
    if (this.$viewer.hasClass('closed')) {
      return false;
    }

    this.$viewer.addClass('closed');
    // Remove hash from url
    if (window.location.hash.indexOf('allMediasViewerGeneric') !== -1) {
      window.history.pushState(null, document.title, window.location.pathname + window.location.search);
    }
    setTimeout(() => {
      genericScrollTo.canIScroll(DEVICE.isMobile);
      const section = this.getSection(this.currentTab);
      section && section.resetOnRedisplay === true && this.resetSection(section);
    }, 550); // based on CSS transition
  },

  scrollToSubsection(subsectionName) {
    const $body = this.$viewer.find(this.bodySelector);
    this.isScrolling = true;
    const $subsection = this.$subsections[this.currentTab].filter(`[data-subsection="${subsectionName}"]`);
    $body.stop().animate({
      scrollTop: $subsection.position().top + $body.scrollTop() - ($subsection.index() === 0 ? 10 : 0) // -10 for the padding top
    }, 250, 'linear', () => {
      this.isScrolling = false;
      this.onScroll($body);
    });
  },

  // Set season from cookie storedSearchParams
  setSeasonPhotos() {
    const storedSearchParams = JSON.parse(cookieManagement.getCookie('storedSearchParams')) || {};
    const arrivalDate = storedSearchParams?.date?.[0]?.value || '';
    const seasonFromDate = arrivalDate === '' ? this.defaultSeason : getSeason(arrivalDate);

    // Reset photos tab when season change
    if (this.currentSeason !== seasonFromDate) {
      const section = this.getSection('photo');
      const $section = this.$viewer.find(this.sectionSelector + '--' + section.name);

      if ($section.hasClass('loaded')) {
        this.resetSection(section);
        this.currentTab = this.currentTab === 'photo' ? null : this.currentTab;

        section.subsections.forEach((subsection) => {
          const cacheKey = `photo${subsection.name}`;
          this.cache[cacheKey].grid = [];
          this.cache[cacheKey].images = [];
        });
      }
    }

    this.currentSeason = seasonFromDate;
  },

  resetSection(section) {
    const $section = this.$viewer.find(this.sectionSelector + '--' + section.name);

    section.subsections.forEach((subsection) => {
      $section.removeClass('loaded loading infinite_loading').find('.allMediasViewerGeneric-subsection[data-subsection="' + subsection.name + '"]').removeClass('disabled allMediasViewerGeneric-grid allMediasViewerGeneric-iframe').find('.allMediasViewerGeneric-subsection-content').html('');
      $section.find('.js-allMediasViewerGeneric-subsection--empty').addClass('disabled');
    });
  },

  goToTab(tab) {
    if (!tab || tab === this.currentTab) {
      return false;
    }

    const $sectionToShow = this.$viewer.find(this.sectionSelector + '--' + tab);
    if ($sectionToShow.length === 0) {
      return false;
    }

    const hashTab = this.getHashTab();
    if (!hashTab || hashTab !== tab) {
      window.history.pushState(null, document.title, window.location.pathname + window.location.search + '#allMediasViewerGeneric[' + tab + ']');
    }

    const previousSection = this.getSection(this.currentTab);
    previousSection && previousSection.resetOnRedisplay === true && this.resetSection(previousSection);

    this.currentTab = tab;

    this.$viewer.find(`${this.sectionSelector}.active, ${this.navSelector}.active`).removeClass('active');
    const $active = this.$viewer.find(this.navSelector + '--' + tab).addClass('active');
    if ($active.length) {
      const $navs = this.$viewer.find('.allMediasViewerGeneric-navs');
      $navs.stop().animate({
        scrollLeft: $navs.scrollLeft() + $active.position().left
      }, 500);
    }

    this.$viewer.removeClass('sticky-top sticky-down');

    const section = this.getSection(tab);
    const nbTabs = this.$tabs.find(`${this.tabSelector}${this.tabSelector}-section--${tab}`).length;

    this.$viewer[section.retractNavOnScroll === true ? 'addClass' : 'removeClass']('retract');
    this.$tabs[nbTabs === 0 ? 'addClass' : 'removeClass']('empty');

    setTimeout(() => {
      this.$tabs.find(this.tabSelector).removeClass('show').filter(`${this.tabSelector}-section--${tab}`).addClass('show');
    }, nbTabs === 0 ? 250 : 0); // based on the transition CSS

    if (!this.$subsections[tab]) {
      this.$subsections[tab] = $sectionToShow.find('> div.allMediasViewerGeneric-subsection[data-subsection]');
    }

    $sectionToShow.addClass('active');
    $sectionToShow.find('div.allMediasViewerGeneric-subsection-content').trigger('updateLayoutGrid');

    if ($sectionToShow.attr('class').indexOf('loading') !== -1) {
      return false;
    }

    if (!$sectionToShow.hasClass('loaded')) {
      return this.getDatas($sectionToShow);
    }
  },

  updateLayoutGrid($grid, cacheKey) {
    /* Refresh grid display after setup or resize */
    const grid = new this.photoGrid({
      minHeight: DEVICE.isDesktop ? 202 : DEVICE.isMobile ? 125 : 233,
      maxHeight: DEVICE.isDesktop ? 223 : DEVICE.isMobile ? 132 : 303,
      getImageMeta: image => image,
      borderWidth: 10
    }, this.cache[cacheKey].grid);
    const $body = this.$viewer.find(this.bodySelector);
    const computedStyle = getComputedStyle($body.get(0));
    let availableWidth = $body.get(0).clientWidth - parseFloat(computedStyle.paddingLeft) - parseFloat(computedStyle.paddingRight);

    if (!DEVICE.navigator.isFirefox) {
      availableWidth += grid.settings.borderWidth;
    }

    const rows = grid.getRows(availableWidth);
    const $elems = $grid.find('.allMediasViewerGeneric-grid--elem');
    let counter = 0;

    rows.forEach((row, indexRow) => {
      const rowItems = row.getItems();
      rowItems.forEach((image, indexImg) => {
        $elems.eq(counter).css({
          width: image.resized.width,
          height: image.resized.height,
          marginLeft: indexImg > 0 ? grid.settings.borderWidth : '',
          marginBottom: indexRow + 1 !== rows.length ? grid.settings.borderWidth : ''
        });
        counter++;
      });
    });
    this.bodyHeight = $body.height();
    this.bodyTop = $body.position().top;
    this.updateCurrentSubsection();
  },

  setCaption(cacheKey) {
    this.cache[cacheKey].images.forEach((i, idx) => {
      this.cache[cacheKey].images[idx].caption = `${idx + 1} / ${this.cache[cacheKey].images.length}`;
    });
  },

  prepareData(data, tab, subsectionName) {
    const cacheKey = `${tab}${subsectionName}`;
    const currentLength = this.cache[cacheKey].grid.length;

    let imageItem = {};

    if (data.length === 0) {
      return;
    }

    data.forEach((item, idx) => {
      const {
        grid_src,
        src,
        width,
        height,
        photoLegend
      } = item;

      let legendToDisplay = '';

      if (typeof photoLegend !== 'undefined') {
        const {
          activityName,
          equipmentName,
          name,
          housingType,
          comfortLevel
        } = photoLegend.legend;

        legendToDisplay = typeof activityName !== 'undefined' ? activityName : typeof housingType !== 'undefined' ? housingType + (typeof comfortLevel !== 'undefined' ? ' ' + comfortLevel : '') + ' - ' + name : typeof equipmentName !== 'undefined' ? equipmentName : '';
      }

      let resolution = DEVICE.isDesktop ? '400x400' : '230x230';

      if (idx + 1 === 9) {
        resolution = DEVICE.isDesktop ? '620x274' : '566x250';
      } else if (idx + 1 === 2 || idx + 1 === 3) {
        resolution = DEVICE.isDesktop ? '330x248' : '268x201';
      }

      item = {
        ...item,
        photoLegend: legendToDisplay
      };

      imageItem = {
        src: grid_src || src,
        width: width,
        height: height,
        index: currentLength + idx,
        photoLegend: legendToDisplay,
        subsectionName: subsectionName
      };

      this.cache[cacheKey].grid[this.cache[cacheKey].grid.length] = imageItem;
      this.cache[cacheKey].images[this.cache[cacheKey].images.length] = item;
    });

    this.setCaption(cacheKey);
  },

  initGrid(nbNewItems, tab, subsection) {
    const cacheKey = `${tab}${subsection.name}`;
    const $grid = this.$subsections[tab].filter(`[data-subsection="${subsection.name}"]`).find('> div.allMediasViewerGeneric-subsection-content');

    for (let currentLength = this.cache[cacheKey].grid.length, i = currentLength - nbNewItems; i < currentLength; i++) {
      $grid.append(this.templates.grid.elem(this.cache[cacheKey].grid[i], tab === 'pixlee' ? true : false));
    }

    $grid.find('img.loading').on('load', e => {
      $(e.currentTarget).removeClass('loading');
    });

    if (typeof (this.$viewer.data(`${cacheKey}[next_page]`)) === 'undefined') {
      const resizeCallback = () => {
        this.updateLayoutGrid($grid, cacheKey);
      };

      $grid.on('updateLayoutGrid', resizeCallback);
      $(window).on('resize', resizeCallback);
      resizeCallback();
    }
  },

  initFancyBox(tab, subsectionName) {
    const isPixlee = tab === 'pixlee';
    const isPhoto = tab === 'photo';
    const cacheKey = `${tab}${subsectionName}`;
    const options = this.fancyboxViewBaseOptions;

    let customData = [];

    if (isPixlee) {
      customData = this.cache[cacheKey].images.map(image => {
        return {
          type: 'inline',
          src: this.templates.lightview.pixlee(image)
        };
      });
      options.baseClass += ' fancyboxPixlee';
    } else if (isPhoto) {
      for (let key in this.cache) {
        this.cache[key].images.forEach((image, idx) => {
          customData.push({
            type: 'inline',
            src: this.templates.lightview.photo(image)
          });
        });
      }
      options.baseClass += ' fancyboxPhoto';
    }

    const random = (Math.random() + 1).toString(36).substring(2);
    const selector = `.js-allMediasViewerGeneric-section--${tab} .allMediasViewerGeneric-grid--elem`;

    this.$viewer.find(selector).not('[class*="fancybox-selector-"]').addClass('fancybox-selector-' + random);

    options.smallBtn = false;
    options.toolbar = true;

    $('.allMediasViewerGeneric-grid--elem:not(.pixlee)').each((index, item) => {
      $(item).attr('data-index', index);
    });

    new FancyboxView({
      selector: `${selector}.fancybox-selector-${random}`,
      popinName: `gallery ${tab}`,
      content: customData ? customData : this.cache[cacheKey].images,
      fancyType: 'build',
      slideClose: false,
      options
    });
  },

  getSection(tab) {
    if (!tab) {
      tab = this.currentTab;
    }
    let index = -1;
    this.config.sections.some((section, idx) => {
      if (section.name === tab) {
        index = idx;
        return true;
      }
    });
    return index >= 0 ? this.config.sections[index] : null;
  },

  drawIframe($section, section, subsection, data) {
    if (window.location.protocol.indexOf('https') !== -1 && data.src.indexOf('https') === -1) {
      if (data.src.indexOf('http://') !== -1) {
        data.src = data.src.replace('http://', 'https://');
      }
    }
    if (data.src.indexOf('vimeo') !== -1) {
      data.src += data.src.indexOf('?') !== -1 ? '&transparent=false' : '';
      // For autofullscreen on mobile WPI-34165
      data.src += DEVICE.isMobile ? '&playsinline=0' : '';
    }
    const $iframe = $(`<iframe class="${data.className || ''}" src="${data.src}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`);
    $iframe.on('load', () => {
      $section.addClass('loaded').removeClass('loading');
    });
    this.$subsections[section.name].filter(`[data-subsection="${subsection.name}"]`).addClass('allMediasViewerGeneric-iframe').find('> div.allMediasViewerGeneric-subsection-content').append($iframe);
  },

  onError($section, subsectionName) {
    const subsections = $section.find(`${this.subSectionSelector}[data-subsection]`);

    subsections.filter(`[data-subsection="${subsectionName}"]`).addClass('disabled');

    const subsectionsDisabled = subsections.filter('.disabled');

    if (subsectionsDisabled.length >= subsections.length) {
      $section.find(`${this.subSectionSelector}--empty`).removeClass('disabled');
    }
  },

  _getDatas($section, section, subsection) {
    let reload = false;
    if (section.name === 'photo') {
      section.ajaxOptions.successCallback = (data) => {
        if (typeof data.data.photos.galerieenvirons === 'undefined' ) $('[data-subsection="environs"]').remove();
        if (typeof data.data.photos.galerierestau === 'undefined' ) $('[data-subsection="restauration"]').remove();

        section.subsections.forEach((subsection, index) => {
          const subSectionName = subsection.name;
          const subSectionLabel = subsection.label;

          let photoSubsection = {};
          let allPhotos = data.data.photos;
          let photosSubsection = typeof allPhotos[subsection.selection] === 'object' ? Object.values(allPhotos[subsection.selection]) : [];

          const sortByOrderName = (a, b) => {
            const format = DEVICE.isDesktop ? '400x400' : '230x230';
            const aOrder = parseInt(a[format].order);
            const bOrder = parseInt(b[format].order);
            return ((aOrder < bOrder) ? -1 : ((aOrder > bOrder) ? 1 : 0));
          };

          photosSubsection.sort(sortByOrderName);

          photosSubsection = Object.keys(photosSubsection).map(function (key, idx) {
            let resolution = DEVICE.isDesktop ? '400x400' : '230x230';

            if (idx + 1 === 9) {
              resolution = DEVICE.isDesktop ? '620x274' : '566x250';
            } else if (idx + 1 === 2 || idx + 1 === 3) {
              resolution = DEVICE.isDesktop ? '330x248' : '268x201';
            }

            photoSubsection = photosSubsection[key][resolution];
            photoSubsection = {
              ...photoSubsection,
              grid_src: photosSubsection[key][resolution].src,
              src: photosSubsection[key]['800x600'].src,
              width: (resolution === '330x248' || resolution === '268x201') ? 640 : (resolution === '620x274' || resolution === '566x250') ? 770 : 500,
              height: (resolution === '330x248' || resolution === '268x201') ? 480 : (resolution === '620x274' || resolution === '566x250') ? 340 : 500,
              type: 'image',
              subsectionLabel: subSectionLabel
            };

            return photoSubsection;
          });

          this.prepareData(photosSubsection, section.name, subSectionName);
          this.initGrid(photosSubsection.length, section.name, subsection);
          $section.addClass('loaded').removeClass('loading infinite_loading');
          this.$viewer.find(`.js-allMediasViewerGeneric-tab-section--${section.name}`).removeClass('disabled');
          this.$subsections[section.name].filter(`[data-subsection="${subsection.name}"]`).addClass('allMediasViewerGeneric-grid');
          $(this.$subsections[section.name].find('> div.allMediasViewerGeneric-subsection-content')[index]).trigger('updateLayoutGrid');

          if (index + 1 === section.subsections.length) {
            this.initFancyBox(section.name, subsection.name);
          }
        });
      };

      section.ajaxOptions.errorCallback = () => {
        this.onError($section, subsection.name);
      };

      section.ajaxOptions.ajaxParams.season = this.currentSeason;
      genericAjaxCall(section.ajaxOptions);
    } else {
      if (typeof subsection.ajaxOptions !== 'undefined') {
        subsection.ajaxOptions.successCallback = (data) => {
          const nbSubsectionsLoaded = (this.$viewer.data(`${section.name}[nb_subsections_loaded]`) || 0) + 1;

          data = subsection.parseData(data);

          if (data.type === 'iframe') {
            return this.drawIframe($section, section, subsection, data);
          }

          this.prepareData(data, section.name, subsection.name);
          this.initGrid(data.length, section.name, subsection);

          if (section.name === 'pixlee' || (nbSubsectionsLoaded === (Object.keys(this.cache).length) - (Object.prototype.hasOwnProperty.call(this.cache, 'pixleepixleeGrid') ? 1 : 0))) {
            this.initFancyBox(section.name, subsection.name);
          }

          if ((subsection.infinite_loading !== true && data.length === 0) || (subsection.infinite_loading === true && data.length === 0 && typeof this.$viewer.data(`${section.name}${subsection.name}[next_page]`) === 'undefined')) {
            this.onError($section, subsection.name);
          }

          if (subsection.infinite_loading === true && typeof (data[0].next_page) !== 'undefined') {
            this.$viewer.data(`${section.name}${subsection.name}[next_page]`, data[0].next_page);
          }

          this.$subsections[section.name].filter(`[data-subsection="${subsection.name}"]`).addClass('allMediasViewerGeneric-grid');

          if (!section.waitAllSubsectionsToEnable) {
            $section.addClass('loaded').removeClass('loading infinite_loading');
            this.$viewer.find(`.js-allMediasViewerGeneric-tab-section--${section.name}${this.tabSelector}--${subsection.name}`).removeClass('disabled');
            this.$subsections[section.name].filter(`[data-subsection="${subsection.name}"]`).find('> div.allMediasViewerGeneric-subsection-content').trigger('updateLayoutGrid');
          } else if (nbSubsectionsLoaded === section.subsections.length) {
            $section.addClass('loaded').removeClass('loading infinite_loading');
            this.$viewer.find(`.js-allMediasViewerGeneric-tab-section--${section.name}`).removeClass('disabled');
            this.$subsections[section.name].find('> div.allMediasViewerGeneric-subsection-content').trigger('updateLayoutGrid');
          }

          this.$viewer.data(`${section.name}[nb_subsections_loaded]`, nbSubsectionsLoaded);
          this.$viewer.find(this.bodySelector).trigger('scroll');
        };

        subsection.ajaxOptions.errorCallback = () => {
          this.onError($section, subsection.name);
        };
      }

      genericAjaxCall(subsection.ajaxOptions);
    }
  },

  getDatas($section) {
    const section = this.getSection();

    section.subsections.forEach((subsection) => {
      $section.addClass(!this.$viewer.data(`${this.currentTab}${subsection.name}[next_page]`) ? 'loading' : 'infinite_loading');

      if (subsection.infinite_loading === true) {
        subsection.ajaxOptions.ajaxParams.page = this.$viewer.data(`${this.currentTab}${subsection.name}[next_page]`) || 1;
      }

      if (!section.ajaxOptions && !subsection.ajaxOptions) {
        const data = subsection.parseData();
        if (data.type === 'iframe') {
          this.drawIframe($section, section, subsection, data);
        }
        return;
      }

      if (section.name !== 'photo') {
        this._getDatas($section, section, subsection);
      }
    });

    if (section.name === 'photo') {
      this._getDatas($section, section, null);
    }
  },

  getFirstVIsibleSubsectionName() {
    if (this.$subsections[this.currentTab].length === 1) {
      return this.$subsections[this.currentTab].eq(0).data('subsection');
    }
    const $visibles = this.$subsections[this.currentTab].filter(`:in-viewport(40%,${this.bodyTop},${this.bodyHeight})`);
    return $visibles.eq($visibles.length - 1).data('subsection');
  },

  updateCurrentSubsection() {
    const subsectionName = this.getFirstVIsibleSubsectionName();
    if (`${this.currentTab}${subsectionName}` !== this.currentSubsection) {
      this.currentSubsection = `${this.currentTab}${subsectionName}`;
      const $active = this.$tabs.find(this.tabSelector).removeClass('active').filter(`${this.tabSelector}-section--${this.currentTab}[data-subsection="${subsectionName}"]`).addClass('active');
      if ($active.length) {
        this.$tabs.stop().animate({
          scrollLeft: this.$tabs.scrollLeft() + $active.position().left + parseInt($active.css('marginLeft'))
        }, 150, 'linear');
      }
    }
    return subsectionName;
  },

  stickyHeader($body) {
    const scrollTop = $body.scrollTop();
    const navHeight = $('.allMediasViewerGeneric-navs').height() + parseInt($('.allMediasViewerGeneric-tabs').css('margin-top'));
    if (scrollTop <= 10 || Math.abs(scrollTop - this.lastScrollTop) > navHeight) {
      this.$viewer.removeClass('sticky-top sticky-down');
      if (scrollTop > 0) {
        this.$viewer.addClass(scrollTop > this.lastScrollTop ? 'sticky-down' : 'sticky-top');
      }
      this.lastScrollTop = scrollTop;
    }
  },

  onScroll($body) {
    // Sticky header class
    this.stickyHeader($body);

    // Update the current subsection
    const subsectionName = this.updateCurrentSubsection();
    const $section = $(`.js-allMediasViewerGeneric-section--${this.currentTab}`);

    let sectionHeight = 0;

    if (!this.$viewer.data(`${this.currentTab}${subsectionName}[next_page]`)) {
      return false;
    }

    if ($section.attr('class').indexOf('loading') !== -1) {
      return false;
    }

    // Infinite scroll
    $section.find('> div').each((idx, d) => {
      sectionHeight += $(d).height();
    });

    if ($body.scrollTop() + $body.height() >= ((sectionHeight > 6000 ? 80 : 60) * sectionHeight / 100)) {
      this.getDatas($section);
    }
  },

  getHashTab() {
    if (window.location.hash.indexOf('allMediasViewerGeneric') !== -1) {
      const search = window.location.hash.match(/\[([^)]+)\]/);
      if (search !== null) {
        return search[1];
      }
    }
    return null;
  },

  initEvents() {
    this.$viewer.find(this.navSelector).on('click', (e) => {
      e.preventDefault();
      this.show($(e.currentTarget).data('anchor'), true);
    });

    this.$viewer.find(this.tabSelector).on('click', (e) => {
      e.preventDefault();
      this.scrollToSubsection($(e.currentTarget).data('subsection'));
      const section = this.getSection();
      if (section.tracking && section.tracking.onClickTab) {
        Tracking.dataLayerPush(section.tracking.onClickTab);
      }
    });

    // Click handler close btn
    this.$viewer.find(this.closeSelector).on('click', e => {
      e.preventDefault();
      this.hide();

      if (this.config.tracking && this.config.tracking.onClose) {
        Tracking.dataLayerPush(this.config.tracking.onClose);
      }
    });

    // On scroll
    this.$viewer.find(this.bodySelector).on('scroll', e => {
      if (this.isScrolling === true) {
        return;
      }
      this.onScroll($(e.currentTarget));
    });

    // Detecting pressing browser's back button
    $(window).on('popstate', () => {
      const hashTab = this.getHashTab();

      if ($('html').hasClass('fancybox-enabled')) {
        fancybox.getInstance('close', true, 0);
      }

      if (!this.$viewer.hasClass('closed')) {
        if (window.location.hash.indexOf('allMediasViewerGeneric') === -1) {
          this.hide();
        } else {
          if (hashTab && hashTab !== this.currentTab) {
            this.goToTab(hashTab);
          }
        }
      } else if (this.$viewer.hasClass('closed') && window.location.hash.indexOf('allMediasViewerGeneric') !== -1) {
        if (hashTab) {
          this.show(hashTab);
        }
      }
    });

    /* Detecting pressing ESC/Echap */
    $(document).on('keydown', (e) => {
      if (!$('html').hasClass('fancybox-enabled')) {
        const focused = $(':focus');
        if (!focused.is('video, textarea, input[type=text], input[type=date], input[type=datetime-local], input[type=month], input[type=number], input[type=password], input[type=range], input[type=search], input[type=tel], input[type=time], input[type=url], input[type=week]')) {
          const key = e.which || e.keyCode || e.charCode;
          if (key === 27 || key === 'Escape') {
            this.hide();
          }
        }
      }
    });
  }
};